export const productList = "PRODUCT_LIST";